<div class="container-fluid" nowWbsucheLibScrollToAndFocus>
  <now-wbsuche-lib-breadcrumb></now-wbsuche-lib-breadcrumb>
  <header class="now-context-info-header now-with-image">
    <div class="now-content-wrap">
      <h1>Weiterbildungssuche: Übersicht Themenfelder</h1>
      <p>
        Wählen Sie zu Ihrer Tätigkeit passende Kategorien, um geeignete Weiterbildungsangebote zu
        finden.
      </p>
    </div>
    <div class="themenfelder-img">
      <img ngSrc="assets/images/u184.svg" priority fill alt="" />
    </div>
  </header>
  <div class="themenfelder-header-spacing">
    <h2>So finden Sie passende Weiterbildungen</h2>
  </div>
  <div id="berufsbereich_card">
    @if ((themenfelderService.ausgewaehlterBildungsbereich$ | async) === null) {
      <now-wbsuche-lib-themenfeld-bildungsbereich-change
        (selectionEmitter)="themenfelderService.onChangeBildungsbereich($event)"
      ></now-wbsuche-lib-themenfeld-bildungsbereich-change>
    } @else {
      <ng-template
        *ngTemplateOutlet="
          headerRowWithEditBtn;
          context: {
            heading: '1. Weiterbildungsziel: ' + (bildungsbereichLabel$ | async),
            editLabel: 'Weiterbildungsziel bearbeiten',
            editEvent: themenfelderService.fullReset
          }
        "
      ></ng-template>
    }
  </div>
  <div id="berufsfeld_card">
    @let themenfelder = themenfelderService.themenfelder$ | async;
    @if ((themenfelderService.ausgewaehlterBildungsbereich$ | async) === null) {
      <h3 class="themenfelder-header-disabled ps-4 mt-3">2. Schritt</h3>
      <hr />
    } @else if ((themenfelderService.ausgewaehltesThemenfeld$ | async) === null) {
      <now-wbsuche-lib-themenfelder-selection
        title="2. Schritt: Wählen Sie Ihr berufliches Themenfeld"
        [weiterbildungen]="themenfelder || []"
        (selectionEmitter)="themenfelderService.onChangeSchwerpunkt($event)"
        (zurueckEvent)="themenfelderService.fullReset()"
        [weiterbildungenLoading]="(loaderService.themenfelderLoading$ | async) || false"
      />
    } @else {
      <hr class="mt-0" />
      <ng-template
        *ngTemplateOutlet="
          headerRowWithEditBtn;
          context: {
            heading:
              '2. Themenfeld: ' +
              (themenfelderService.ausgewaehltesThemenfeld$ | async)?.kurzBezeichnungNeutral,
            editLabel: 'Themenfeld bearbeiten',
            editEvent: themenfelderService.resetSchwerpunkt
          }
        "
      ></ng-template>
    }
  </div>
  <div id="schwerpunkt_card">
    @let themenfeldSchwerpunkte = themenfelderService.themenfeldSchwerpunkte$ | async;
    @let hasNoSchwerpunkte = themenfeldSchwerpunkte?.length === 0;
    @if ((themenfelderService.ausgewaehltesThemenfeld$ | async) === null) {
      <h3 class="themenfelder-header-disabled ps-4 mt-3">3. Schritt</h3>
      <hr />
    } @else if ((themenfelderService.ausgewaehlterSchwerpunkt$ | async) === null) {
      <now-wbsuche-lib-themenfelder-selection
        nowWbsucheLibScrollToAndFocus
        title="3. Schritt: Wählen Sie Ihren Schwerpunkt"
        [weiterbildungen]="themenfeldSchwerpunkte || []"
        (selectionEmitter)="themenfelderService.onChangeSpezialisierung($event)"
        (zurueckEvent)="themenfelderService.resetSchwerpunkt()"
        [weiterbildungenLoading]="(loaderService.themenfeldSchwerpunkteLoading$ | async) || false"
      />
    } @else {
      <hr class="mt-0" />

      <ng-template
        *ngTemplateOutlet="
          headerRowWithEditBtn;
          context: {
            heading:
              '3. Schwerpunkt' +
              (!hasNoSchwerpunkte
                ? ': ' +
                  (themenfelderService.ausgewaehlterSchwerpunkt$ | async)!.kurzBezeichnungNeutral
                : ''),
            editLabel: 'Schwerpunkt bearbeiten',
            editEvent: themenfelderService.resetSpezialisierung,
            hasNoSchwerpunkte: hasNoSchwerpunkte
          }
        "
      ></ng-template>
    }
  </div>
  <div id="spezialisierung_card">
    @let themenfeldSpezialisierungenMitCounts = themenfeldSpezialisierungenMitCounts$ | async;
    @if ((themenfelderService.ausgewaehlterSchwerpunkt$ | async) === null) {
      <h3 class="themenfelder-header-disabled ps-4 mt-3">4. Schritt</h3>
    } @else {
      <div
        class="now-decorative-card now-decorative-card-small ps-4 themenfelder-header-hyphens"
        nowWbsucheLibScrollToAndFocus
      >
        <h3>4. Schritt: Wählen Sie Ihre Spezialisierung</h3>
        @if (
          (loaderService.themenfeldSpezialisierungenLoading$ | async) === false &&
          (loaderService.suchwortCountsLoading$ | async) === false
        ) {
          <ul class="now-link-list">
            @for (
              spezialisierung of themenfeldSpezialisierungenMitCounts;
              track spezialisierung.kurzBezeichnungNeutral
            ) {
              <li class="now-icon-arrow-right">
                <a
                  [class]="{ disabled: spezialisierung.count === 0 }"
                  [routerLink]="spezialisierung.count > 0 ? ['/'] : null"
                  [queryParams]="{
                    sw: spezialisierung.kurzBezeichnungNeutral,
                    ziel: themenfelderService.ausgewaehlterBildungsbereich$ | async
                  }"
                  >{{ spezialisierung.kurzBezeichnungNeutral }} ({{ spezialisierung.count }})</a
                >
              </li>
            }
          </ul>
        } @else {
          <p>Daten werden geladen...</p>
        }

        <button
          type="button"
          class="now-btn now-btn-secondary mt-3"
          (click)="
            hasNoSchwerpunkte
              ? themenfelderService.resetSchwerpunkt()
              : themenfelderService.resetSpezialisierung()
          "
        >
          Zurück
        </button>
      </div>
    }
  </div>
</div>

<ng-template
  #headerRowWithEditBtn
  let-heading="heading"
  let-editLabel="editLabel"
  let-editEvent="editEvent"
  let-hasNoSchwerpunkte="hasNoSchwerpunkte"
>
  <div class="d-flex gap-2 justify-content-between align-items-center ps-4 mt-3">
    <div class="themenfelder-header-hyphens" [ngClass]="{ 'text-disabled': hasNoSchwerpunkte }">
      <h3 [ngClass]="{ 'mb-x-small': hasNoSchwerpunkte }">{{ heading }}</h3>
      @if (hasNoSchwerpunkte) {
        <div class="mb-large">
          Für das ausgewählte Themenfeld sind keine Schwerpunkte vorhanden. Sie können direkt mit
          Schritt 4 fortfahren.
        </div>
      }
    </div>
    @if (!hasNoSchwerpunkte) {
      <div class="align-self-start me-4">
        <now-wbsuche-lib-bearbeiten-button
          [label]="editLabel"
          (resetEmitted)="editEvent()"
        ></now-wbsuche-lib-bearbeiten-button>
      </div>
    }
  </div>
</ng-template>
